<template>
<div class="animated fadeIn custom-cases bgV2">
    <div class="d-flex headerOrderDetail" v-if="Item && Item.id">
        <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
            <div class="mt-20 pl-20">
                <h1 class="mb-1">{{Item.case_number}}</h1>
            </div>
            <h4 class="c-orange mb-0">{{Item && Item.status && Item.status != 'New' ? Item.status : ''}}</h4>
        </div>
    </div>
    <b-row>
        <b-col md="12">
            <gofix-tab class="mt-3" :responsive="responsive" :variableWidth="true" :is-reload-tab="true" :data="$route.params.id == '0' ? tabDataNewCase : tabData" @load-tab="loadTab" arrows ref="goFixTab">
                <template slot="gofixTab:right">
                    <template v-if="Item && Item.id && $checkRole($accessModule.change_hot_button_case_status, 'change_hot_button_case_status')">
                        <!-- <gofix-button 
                            label="In Progress" 
                            outline
                            class="ml-3" 
                            v-if="Item.status == 'Assigned'" 
                            @click="changeStatusCase('In Progress')">
                        </gofix-button> -->
                        <gofix-button 
                            label="Close" 
                            outline
                            class="ml-3"
                            v-if="Item.status == 'Open'"
                            @click="modals.closeCase.open = true">
                        </gofix-button>
                        <gofix-button 
                            label="Reopen" 
                            outline
                            class="ml-3"
                            v-if="Item.status == 'Closed'"
                            @click="modals.reOpen.open = true">
                        </gofix-button>
                        <!-- <gofix-button 
                            label="Cancel" 
                            outline
                            class="ml-3"
                            v-if="!['Cancelled', 'Closed'].includes(Item.status) && $checkRole($accessModule.case_management_cancel, 'cancel_case')"
                            @click="openReasonCancelCase">
                        </gofix-button> -->
                    </template>
                    <gofix-button 
                        v-if="tabActive == 'basic-info'"
                        label="Save"
                        class="ml-3" 
                        :loading="isAction"
                        :disabled="$disabledCreateOrUpdate(this.Item, $accessModule.case_management) || (Item && Item.id != 0 && ['Repeated Feedback', 'Cancelled', 'Closed'].includes(Item.status))"
                        @click="save" >
                    </gofix-button>
                </template>
                <template slot="gofixTab:basic-info">
                    <CaseBasicInfo ref="basic_info" @resetData="getCaseEdit"/>
                </template>
                <template slot="gofixTab:work-folder">
                    <WorkFolder />
                </template>
                <template slot="gofixTab:activity-log">
                    <global-activities 
                        ref="globalActivities" 
                        activityType="Case" 
                        :activityId="$route.params.id" 
                        isCaseActivity 
                        caseType="Case Hot Button"
                        :disableImport="true" 
                        :controls="{
                            create: !($disabledCreateOrUpdate(this.Item, $accessModule.case_management) || (Item && Item.id != 0 && ['Repeated Feedback', 'Cancelled', 'Closed'].includes(Item.status))), 
                            delete: false, 
                            update: !($disabledCreateOrUpdate(this.Item, $accessModule.case_management) || (Item && Item.id != 0 && ['Repeated Feedback', 'Cancelled', 'Closed'].includes(Item.status)))
                        }" 
                        isShowDropdownLogType 
                        :item="Item" 
                        nameTable="case-activity-log"
                        @reloadCase="getCaseEdit">
                </global-activities>
                </template>
                <template slot="gofixTab:case-reporting">
                    <CaseReporting />
                </template>
                <template slot="gofixTab:repeated-feedback">
                    <CaseRepeatedFeedback @update-total="total => repeatedFeedbackTotal = total" />
                </template>
                <template slot="gofixTab:after-title:repeated-feedback" v-if="Item && Item.repeated_feedback">
                    <p class="navbar-title-after">&nbsp;({{Item.repeated_feedback.length}})</p>
                </template>
            </gofix-tab>
        </b-col>
    </b-row>
    <b-modal :no-close-on-backdrop="true" id="modal-select-invoice" title="Recent Cases of the same property" hide-footer :centered="true" ref="modal-merge-case" @hide="hideModalMergeCase">
        <b-row class="content">
            <b-col md="12">
                <div class="scollingTable similarModal">
                    <gofix-table :settings="tableConfig" :table-items="tableItems" @load-items="getTableData" ref="gofixTable">
                        <template slot="gofix_table:case_number" slot-scope="row">
                            <span class="checklistLink" @click="gotoDetail(row.item)"> {{row.item.case_number}} </span>
                        </template>
                        <template slot="gofix_table:created_at" slot-scope="row">
                            {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                    </gofix-table>
                </div>

                <b-button-group class="d-block text-right">
                    <gofix-button label="SAVE" @click="raiseNewCase(1)" noBorder></gofix-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-modal>
    <!-- Cancel Case -->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" :title="'Cancel Case #' + Item.case_number" hide-footer hide-header :centered="true" v-model="modals.warning.open">
            <div class="center">
               There is an WO associated with Case! <br/>You need to handle the WO separately.<br/>Do you want to proceed?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.warning.open = false">No</b-button>
                <b-button class="custom-btn" @click="openReasonCancelCase" :disabled="modals.warning.loading">
                    <b-spinner v-if="modals.warning.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
    </b-modal>
    <b-modal
        :no-close-on-backdrop="true"
        id="modal-Create"
        size="lg"
        :title="'Cancel Case #' + Item.case_number"
        hide-footer
        :centered="true"
        v-model="modals.cancel.open">
        <b-row>
            <b-col>
                <b-form class="formV2" v-bind:class="{'run-loading':modals.cancel.loading}">
                    <gofix-form-input-textarea
                        label="Reason for Cancellation"
                        class="h-100"
                        required
                        v-model="modals.cancel.data.reason">
                    </gofix-form-input-textarea>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="updateCaseCancellation" :loading="modals.cancel.loading" noBorder></gofix-button>
                    </b-button-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.closeCase.open">
            <div class="center">
                Are you sure this issue has resolved and no further update required?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.closeCase.open = false">No</b-button>
                <b-button class="custom-btn" @click="clickClose" :disabled="modals.closeCase.loading">
                    <b-spinner v-if="modals.closeCase.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.reOpen.open">
            <div class="center">
                Are you sure you want to reopen <br/><b>the case?</b>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.reOpen.open = false">No</b-button>
                <b-button class="custom-btn" @click="clickReOpen" :disabled="modals.reOpen.loading">
                    <b-spinner v-if="modals.reOpen.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
    </b-modal>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
const CaseBasicInfo = () => import("./BasicInfo")
const WorkFolder = () => import("./WorkFolder")
const globalActivities = () => import("../global/Activities")
const CaseReporting = () => import("./CaseReporting")
const CaseRepeatedFeedback = () => import("./CaseRepeatedFeedback")

export default {
    name: 'case-hot-detail',
    components: {
        WorkFolder,
        CaseReporting,
        CaseRepeatedFeedback,
        globalActivities,
        CaseBasicInfo
    },
    data() {
        return {
            tabData: [{
                    key: "basic-info",
                    title: "Basic Info",
                    active: true
                },
                // {
                //     key: "work-folder",
                //     title: "Work Folder",
                //     active: false
                // },
                {
                    key: "activity-log",
                    title: "Activity log",
                    active: false
                },
                {
                    key: "case-reporting",
                    title: "Case Reporting",
                    active: false
                },
                // {
                //     key: "repeated-feedback",
                //     title: "Repeated Feedback",
                //     active: false
                // }
            ],
            tabDataNewCase: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            }, ],
            valid: false,
            Validate: false,
            clickedCancel:false,
            clickedCompleted:false,
            // checkStatusSetting: true,
            tableItems: [],
            tableConfig: {
                name: 'similar_case',
                controls: {
                    reload: false,
                    create: false,
                    delete: false,
                    createPWO: false,
                    enable: false,
                    assign: false,
                    changeStatus: false,
                    tableFilter: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tablePagination: false,
                },
                filter: {},
                page: 1,
                limit: 100,
                total: 0,
                fields: [{
                        key: 'case_number',
                        label: 'Case number',
                        thStyle: "width:70px"
                    },
                    {
                        key: 'primary_location',
                        label: 'Primary location',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'service_category_name',
                        label: 'Category',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'feedback_detail',
                        label: 'Issue',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'created_at',
                        label: 'Created at',
                        thStyle: "width:100px"
                    }
                ]
            },
            timer: {
                fm_staff: null,
                supplier: null,
                company: null,
                contract: null,
                equipment: null,
                location: null,
                requestor: null,
                fault_type: null,
                property: null,
                closeCase: null,
                save: null,
                reOpen: null,
            },
            modals: {
                cancel:{
                    open:false,
                    loading:false,
                    data:{
                        reason:null
                    }
                },
                warning:{
                    open:false,
                    loading:false
                },
                closeCase: {
                    open: false,
                    loading: false
                },
                reOpen: {
                    open: false,
                    loading: false
                }
            },
            loading: {
                createCase: false,
            },
            isAction: false,
            repeatedFeedbackTotal: 0,
            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            isMergeCase: true,
            tabActive: 'basic-info'
        }
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            Item: "CaseHotButtonController/Item",
        })
    },
    mounted: function () {
        window.onpopstate = (event) => {
            if(this.$route.params.id == '0'){
                this.$store.commit("CaseHotButtonController/setItemToCreate");
                return;
            }
            if(this.$route.params.id){
                this.getCaseEdit();
            }
        }
    },
    async created() {
        this.getCaseEdit();
    },
    methods: {
        getCaseEdit() {
            if(!this.$route.params.id || this.$route.params.id == '0') {
                this.$store.commit("CaseHotButtonController/setItemToCreate");
                return
            }
            this.$store.dispatch('CaseHotButtonController/getCase', { case_id: this.$route.params.id })
            .catch(err => {
                this.$alertNotification("Can not load the case", "danger");
            })
        },        
        async getTableData(callback) {
            let request = JSON.parse(JSON.stringify(this.$refs.basic_info.CaseObj));
            const {
                tableRequest,
                resolve,
                reject
            } = await callback();
            tableRequest.filter.location_id = (request.location && request.location.id) ? request.location.id : null;
            tableRequest.filter.client_contract_id = request.contract.id
            tableRequest.isCMS = 0;
            await this.$store.dispatch("CaseHotButtonController/getSimilarCase", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification(err, "danger");
                    reject();
                })
        },
        async modalMergeCase(obj) {
            let isExist = false;
            const tableRequest = {
                filter: {}
            };
            tableRequest.filter.location_id = obj.location.id;
            tableRequest.filter.client_contract_id = obj.contract.id
            tableRequest.getSimilarCase = true
            this.isMergeCase = false
            await this.$store.dispatch("CaseHotButtonController/getSimilarCase", tableRequest)
                .then(response => {
                    this.isAction = false;
                    if (response.data.data.items.length) {
                        isExist = true;
                        this.$refs['modal-merge-case'].show();
                    }
                })
                .catch(err => {
                  this.isAction = false;
                    this.$alertNotification("Can not load the similar case", "danger");
                })
            return isExist
        },
        hideModalMergeCase() {
            this.isMergeCase = true
        },
        raiseNewCase() {
            let request = JSON.parse(JSON.stringify(this.$refs.basic_info.CaseObj));
            this.storeCase(request)
        },
        async save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                let isValidate = this.$refs.basic_info.validateWhenSubmit()
                if(!isValidate) return

                let request = JSON.parse(JSON.stringify(this.$refs.basic_info.CaseObj))

                if(!request.id && request.contract.case_hot_button_settings && request.contract.case_hot_button_settings.hasOwnProperty('detect_existing_cases_of_the_same_property') && request.contract.case_hot_button_settings.detect_existing_cases_of_the_same_property == true) {
                    let isExistCase = await this.modalMergeCase(request)
                    if(isExistCase) return
                }
                
                if(this.isAction) return
                this.isAction = true
                this.storeCase(request)
            }, 300)
        },
        storeCase(request, is_link_case = false) {
            // if(is_link_case) {
            //     let obj = JSON.parse(JSON.stringify(this.$refs.basic_info.CaseObj));
            //     obj.case_number = request.case_number
            //     request = obj
            // } else {
            //     request.case_number = null;
            // }

            if (request.reported_date && request.reported_time) {
                //Check vaidate reported_time
                let reported_time_validate = request.reported_time;
                reported_time_validate = reported_time_validate.split(':');
                if(reported_time_validate[0] == 'HH' || reported_time_validate[1] == 'mm'){
                  this.isAction = false;
                    return this.$alertNotification("Please enter the exact Time Reported field", "danger");
                }

                let time = moment(request.reported_date).format("YYYY-MM-DD") + " " + request.reported_time
                request.reported_time = moment(time, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
            }

            const requestParmas = {
                id: request.id,
                // case_number: request.case_number,
                client_contract_id: request.contract.id,
                property_id: request.properties.id,
                reported_time: request.reported_time,
                recorded_time: `${moment(request.recorded_date, "DD.MM.YYYY").format("YYYY-MM-DD")} ${request.recorded_date_time}`,
                location_id: request.location.id,
                service_category_id: request.service_categories.id,
                feedback_detail: request.feedback_detail,
                priority: request.sla.id,
                officer_in_charge_id: request.user.user_id,
                proposed_timeline: moment(request.proposed_timeline).format("YYYY-MM-DD"),
                other_locations: request.other_locations,
                deliverables: request.deliverables,
                status: request.status,
                avenue_of_feedback: request.avenue_of_feedback ? request.avenue_of_feedback.reference_value_text:null,
                avenue_feedback_type:request.avenue_of_feedback ? request.avenue_of_feedback.reference_value_abbr:null,
                nature_of_feedback: request.nature_feedback && request.nature_feedback.id ? request.nature_feedback.name : null,
                nature_feedback_id: request.nature_feedback && request.nature_feedback.id ? request.nature_feedback.id : null,
            }

            let keyMessage = 'adding'
            if (this.$route.params.id != "0") {
                keyMessage = 'editing'
            }
            this.$store.dispatch('CaseHotButtonController/raiseCase', requestParmas)
                .then(async (result) => {
                    this.$refs['modal-merge-case'].hide();
                    if (this.$route.params.id == "0") {
                        await this.$refs.basic_info.uploadPhotos(0, result.data.data.id);
                        await this.$router.push({
                            name: 'case-detail-hb-info',
                            params: {
                                id: result.data.data.id
                            }
                        })
                    }
                    await this.getCaseEdit()
                    await this.$alertNotification(this.$notificationV2(keyMessage, 'case'));
                    this.isAction = await false;
                }).catch(err => {
                    this.isAction = false;
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "warning");
                    }
                })
        },
        /* --- Change status --- */
        clickClose() {
            if (!this.Item || (this.Item.case_type == 'Estate Spot Check' && this.Item.case_action_taken_id === null)) {
                let msg = "The person-in-charge must add Action Taken before the case can be closed"
                if(this.Item.officer_in_charge_id == this.UserLogin.id) {
                    msg = "Please add Action Taken"
                }
                return this.$alertNotification(msg, "danger");
            }

            if (this.timer.closeCase) {
                clearTimeout(this.timer.closeCase);
                this.timer.closeCase = null;
            }
            this.timer.closeCase = setTimeout(async () => {
                if(this.modals.closeCase.loading) return
                this.modals.closeCase.loading = true;
                await this.changeStatusCase("Closed")
                this.modals.closeCase.loading = await false;
                this.modals.closeCase.open = await false;
            }, 300)
        },
        clickReOpen() {
            if (this.timer.reOpen) {
                clearTimeout(this.timer.reOpen);
                this.timer.reOpen = null;
            }
            this.timer.reOpen = setTimeout(async () => {
                if(this.modals.reOpen.loading) return
                this.modals.reOpen.loading = true;
                await this.changeStatusCase("Open")
                this.modals.reOpen.loading = await false;
                this.modals.reOpen.open = await false;
            }, 300)
        },
        async changeStatusCase(status) {
            let request = {
                status: status,
                id: this.Item.id,
                service_category_id: this.Item.service_category_id,
                client_contract_id: this.Item.client_contract_id,
                property_id: this.Item.property_id,
                location_id: this.Item.location_id,
                isChangeStatus: true
            }

            await this.$store.dispatch('CaseHotButtonController/raiseCase', request)
                .then(async (result) => {
                    await this.getCaseEdit();
                    await this.$alertNotification(this.$notificationV2('editing', 'case'));
                }).catch(err => {
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "warning");
                    }
                })
        },
        /* --- Canel case --- */
        openReasonCancelCase(){
            this.modals.cancel.open = true;
            this.modals.warning.open = false;
        },
        updateCaseCancellation(){
            if(!this.modals.cancel.data.reason){
                return this.$alertNotification("You must provide Reason for Cancellation!", "danger");
            }
            let request = {
                status: "Cancelled",
                reason: this.modals.cancel.data.reason,
                id: this.Item.id
            }
            this.clickedCancel = !this.clickedCancel;
            this.$store.dispatch('CaseHotButtonController/raiseCase', request)
                .then(async (result) => {
                    this.getCaseEdit()
                    this.modals.cancel.open = false;
                    this.modals.cancel.loading = false;
                    await this.$alertNotification(this.$notificationV2('editing', 'case'));
            }).catch(err => {
                this.modals.cancel.loading = false;
                if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "warning");
                }
            })
        },
        loadTab(tab) {
            this.tabActive = tab.key
        },
         /* --- Detect existing cases of the same property --- */
        gotoDetail(item) {
            if (item.id) {
                window.open(`#/v2/case/hot-button/${item.id}`);
            }
        },
    }
}
</script>
